import { render } from "./loanConfiguration.vue?vue&type=template&id=38f745f0&scoped=true"
import script from "./loanConfiguration.vue?vue&type=script&lang=js"
export * from "./loanConfiguration.vue?vue&type=script&lang=js"

import "./loanConfiguration.vue?vue&type=style&index=0&id=38f745f0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f745f0"]])

export default __exports__